import styled from 'styled-components';

export default styled.div`
  display: flex;
  position: relative;
  margin-top: 15px;
`;
